import React from 'react';
import Information from './modals/common/Information';
import { messageUtility } from '../utilities/messageUtility';

export const FormInformationDialog = props => {
  const {
    title,
    message,
    onClose,
    tabFocus = false,
    buttonText,
    multilineText = true,
    rootClassName,
    buttonClassName,
  } = props.dialog || {};
  return (
    <Information
      visible={true}
      title={title}
      message={message}
      buttonText={buttonText || messageUtility.getMessage('I-000-017')}
      buttonClassName={buttonClassName}
      onClose={onClose}
      rootClassName={rootClassName}
      multilineText={multilineText}
      tabFocus={tabFocus}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/FormInformationDialog.jsx